<template>
    <section id="checklists">
        <template v-for="checklist in checklists">
            <ChecklistItem :checklist="checklist" />
        </template>
    </section>
</template>

<script>
import ChecklistItem from '@/components/checklist_item.vue'

export default {
    name: 'FeaturedChecklists',
    props: [
        'token',
    ],
    components: {
        ChecklistItem,
    },
    data: function(){
        return {
            checklists: [],
            activeTags: []
        }
    },
    mounted() {
        let useToken = process.env.VUE_APP_API_TOKEN;
        if (this.$props.token) {
            useToken = this.$props.token;
        }

        let url = `${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/?detail=1&featured=1`;

        console.log(url)

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: `token ${useToken}`
            }
        })
            .then(response => response.json())
            .then(data => {
                this.checklists = data;
            })
            .catch(error => console.log(error))
    }
}
</script>